import { ToolType } from "api/resources/aiTools/types"

import Paper from "../../../Paper"
import AIToolsError from "../../helpers/AIToolsError"
import { InputDisplay } from "../../helpers/InputDisplay"
import { QuizReturnType } from "../../QuizGenerator/useQuiz"
import OutputToolbar from "../OutputToolbar"
import ToolOutput from "../ToolOutput"

const QuizOutput = (
  props: Pick<
    QuizReturnType,
    | "output"
    | "isLoading"
    | "isPositiveResponse"
    | "currentResponseId"
    | "setCurrentResponseId"
    | "regenerateResponse"
    | "overviewData"
    | "responseIds"
    | "userVote"
    | "onBack"
    | "stream"
    | "streamPro"
    | "isError"
  >
) => {
  const {
    output,
    overviewData,
    responseIds,
    currentResponseId,
    isPositiveResponse,
    setCurrentResponseId,
    userVote,
    regenerateResponse,
    isLoading,
    onBack,
    isError,
  } = props

  const isPro =
    (overviewData?.numberOfIndividualQuestions || 0) > 0 ||
    (overviewData?.numberOfComprehensions || 0) > 0

  if (isPro && overviewData?.numberOfQuestions) {
    // eslint-disable-next-line react-hooks/immutability
    overviewData.numberOfQuestions = 0
  }

  return (
    <div className="mb-4 flex flex-col gap-2">
      {overviewData && !isError && <InputDisplay data={{ ...overviewData }} />}
      {isError ? (
        <AIToolsError onClick={onBack} />
      ) : (
        <Paper
          className="overflow-x-auto p-0"
          endSlot={
            isLoading ? undefined : (
              <OutputToolbar
                toolType={
                  overviewData?.isPro ? ToolType.quizPro : ToolType.quiz
                }
                responseIds={responseIds}
                currentResponseId={currentResponseId}
                copyText={output}
                isPositiveResponse={isPositiveResponse}
                onResponseIdChange={responseId => {
                  setCurrentResponseId(responseId)
                }}
                onUserReaction={reaction => {
                  userVote.mutate({ reaction, isPro: overviewData!.isPro })
                }}
                onRegenerate={reason => {
                  regenerateResponse.mutate({
                    reason,

                    isPro: overviewData!.isPro,
                  })
                }}
              />
            )
          }
        >
          <div>
            <ToolOutput
              isLoading={isLoading}
              onClick={() => {
                if (responseIds) {
                  setCurrentResponseId(
                    responseIds?.length > 1
                      ? responseIds[responseIds?.length - 1]
                      : responseIds[0]
                  )
                }
              }}
            >
              {output}
            </ToolOutput>
          </div>
        </Paper>
      )}
    </div>
  )
}

export default QuizOutput
